import { jsx as _jsx } from "react/jsx-runtime";
import { SimplePagination, Table } from '@dixa/lib-shared-habla';
export function ListingFoot({ hasNextPage, hasPreviousPage, nextPage, previousPage, asyncStatus, }) {
    const hasFoot = hasNextPage || hasPreviousPage;
    if (!hasFoot)
        return null;
    return (_jsx(Table.Tfoot, { children: _jsx(Table.Tr, { children: _jsx(Table.Td, { children: _jsx(SimplePagination, { previousButtonClick: previousPage, previousButtonDisabled: !hasPreviousPage, nextButtonClick: nextPage, nextButtonDisabled: !hasNextPage, loading: asyncStatus === 'loading' }) }) }) }));
}
